import quickFactStickerBlackCat from '../images/QuickFact_sticker_black_cat.png';
import quickFactStickerChihuahua from '../images/QuickFact_sticker_chihuahua.png';
import quickFactStickerOrangeCat from '../images/QuickFact_sticker_orange_cat.png';
import quickFactStickerPugHangingPaws from '../images/QuickFact_sticker_pug_hanging_paws.png';

// The stickers a page can choose from, as the props `QuickFact` takes. The negative offsets seat
// each sticker's ledge on the bottom edge of the band.
export const QUICK_FACT_STICKERS = {
  chihuahua: { stickerImageSrc: quickFactStickerChihuahua, stickerBottom: '0' },
  orangeCat: { stickerImageSrc: quickFactStickerOrangeCat, stickerBottom: '-12px' },
  pugHangingPaws: { stickerImageSrc: quickFactStickerPugHangingPaws, stickerBottom: '-26px' },
  blackCat: { stickerImageSrc: quickFactStickerBlackCat, stickerBottom: '-28px' },
} as const satisfies Record<string, { stickerImageSrc: string; stickerBottom: string }>;

export type QuickFactStickerName = keyof typeof QUICK_FACT_STICKERS;
